function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createMemoStyles } from '@wds/styles';
var useMobileNavStyles = createMemoStyles(function (_ref) {
  var breakpoints = _ref.breakpoints,
    palette = _ref.palette,
    spacing = _ref.spacing,
    radius = _ref.radius,
    height = _ref.height,
    type = _ref.type;
  return {
    mobileNavContainer: function mobileNavContainer(props) {
      var _ref2;
      return _ref2 = {
        display: 'flex',
        justifyContent: props !== null && props !== void 0 && props.title ? 'left' : 'center',
        alignItems: 'center',
        width: '100%',
        height: spacing[7],
        color: palette.text.dark
      }, _defineProperty(_ref2, "@media (min-width: ".concat(breakpoints.md, "px)"), {
        justifyContent: 'left',
        marginLeft: spacing[8]
      }), _defineProperty(_ref2, '& > div > div > .wds-overlay', {
        top: height
      }), _ref2;
    },
    mobileNavBoxFull: {
      width: '100%'
    },
    mobileNavLogo: function mobileNavLogo(props) {
      return {
        width: props !== null && props !== void 0 && props.title ? 'initial' : '100%',
        textAlign: props !== null && props !== void 0 && props.title ? 'left' : 'center'
      };
    },
    createButton: {
      display: 'inline-block',
      backgroundColor: palette.primary.main,
      color: palette.text.light,
      padding: spacing[4],
      position: 'fixed',
      right: spacing[4],
      bottom: spacing[4],
      borderRadius: radius.large
    },
    mobileNavMenu: {
      '& > ul > li, & > ul > ul > li ': {
        '& > [role="button"], & > a': {
          borderLeft: "8px solid transparent",
          borderBottom: "solid 1px ".concat(palette.border.main),
          cursor: 'pointer',
          '& > span': {
            fontSize: type.fontSize.body
          },
          '&:hover, &:active, &:focus': {
            background: palette.background.light,
            borderLeft: "8px solid ".concat(palette.primary.main)
          }
        },
        '& > [role="region"] > ul li > a': {
          borderLeft: "8px solid transparent",
          background: palette.background.accent,
          '&:hover, &:focus': {
            borderLeft: "8px solid ".concat(palette.primary.main)
          }
        }
      }
    }
  };
});
export default useMobileNavStyles;
//# sourceMappingURL=useStyles.js.map